import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/adsStyle.js";


const useStyles = makeStyles(styles);

export default function Ads3() {
  const classes = useStyles();
  return (
    <div className={classes.bannerSection}>
      <div>
        <GridContainer justify="center" >
          <GridItem xs={12} sm={10} md={10}>
            <GridContainer justify="center" >
              <GridItem xs={12} sm={12} md={4}>
              <a target='_blank' href='https://tpan.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/tpan.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
             
              <GridItem xs={12} sm={12} md={4}>
              <a target='_blank' href='https://www.ustmb.ac.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/ustmb1.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
              <a target='_blank' href='https://www.saminray.com/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/saminray.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
        <br />
        <br />
        <GridContainer justify="center" >
          <GridItem xs={12} sm={10} md={10}>
            <GridContainer justify="center" >
            <GridItem xs={12} sm={12} md={4}>
              <a target='_blank' href='https://trez.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/trez.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
              <a target='_blank' href='https://www.xaas.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/xaas1.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
             
              <GridItem xs={12} sm={12} md={4}>
                <a target='_blank' href='https://dayatadbir.com/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/dayatadbir.png"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
